export default {
  label: 'English',
  labelMobile: 'EN',
  breadcrumb: {
    home: 'Home',
    SimulationsView: 'Simulations',
    ResultsView: 'Results',
    TracingView: 'Tracing',
    GeneralParameterizationView: 'General Parameterization',
    HvoExportsView: 'HVO Exports',
  },
}
